export enum MentionImportTypesEnum {
    GENERIC_CSV = 'GENERIC_CSV',
    CISION = 'CISION',
    FACTIVA = 'FACTIVA',
    MELTWATER = 'MELTWATER',
    NEWSDESK = 'NEWSDESK'
}
